export default __webpack_public_path__ + "static/media/reset-icon.b3d67621.svg";